<template>
  <div id="contenedor-main-expediente-contrato">
    <expediente
      :idReferencia="idReferencia"
      :soloLectura="soloLectura"
      moduloExpedienteOrigen="contratos">
    </expediente>
  </div>
</template>

<script>
import Expediente from '@/views/administracion/expedientes/Main.vue';

export default {
  name: 'ExpedienteContratoMain',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Expediente,
  },
  data() {
    return {
      idReferencia: this.$route.params.idContrato,
    };
  },
};
</script>

<style>
</style>
